import { createContext, useContext } from "react";
import { NavigationBlockReturn } from "./useNavigationBlock";

export const NavigationBlockContext =
  createContext<NavigationBlockReturn | null>(null);

const useNavigationBlockContext = () => {
  const context = useContext(NavigationBlockContext);
  if (!context) {
    throw new Error(
      "useNavigationBlockContext must be used within NavigationBlockProvider"
    );
  }
  return context;
};

export default useNavigationBlockContext;
